import React from 'react';

const NewsArticleFormModal = React.lazy(() => import('../components/FormModal'));
const newsArticleModalRegistry = {
    company_newsArticleId: NewsArticleFormModal
};
export default newsArticleModalRegistry;
